module.exports = __webpack_public_path__ + "static/media/what.2230bd92.webp";